module.exports = __webpack_public_path__ + "static/css-85e508b1731b7fc460fc63424d9923d4.png";